interface CommentsIconProps {
  onClick?: () => void;
}

export default function CommentsIcon({ onClick }: CommentsIconProps) {
  return <a className="bi bi-chat-left-text comments-icon" onClick={onClick}></a>;
}
